module.exports = __webpack_public_path__ + "9407072d58edc368a5e138d9ee70a601.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/fr.json
// module id = 1157
// module chunks = 0